// Catalogue selector: clicking a category card switches the active display panel.
// Matching is index-based (Nth category ↔ Nth panel).

function initProductsSelector() {
  const section = document.querySelector('.products-block')
  if (!section) {
    return
  }

  const categories = Array.from(section.querySelectorAll('.tease-product-cat'))
  const panels = Array.from(section.querySelectorAll('.products-display-panel'))
  if (!categories.length || !panels.length) {
    return
  }

  const activate = (index) => {
    categories.forEach((cat, i) => cat.classList.toggle('is-active', i === index))
    panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index))
  }

  categories.forEach((category, index) => {
    category.addEventListener('click', () => activate(index))
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductsSelector)
} else {
  initProductsSelector()
}
